export const normalizeCurrencyValue = (value) => {
  if (value === null || value === undefined) return '';

  const text = String(value).trim();
  if (!text) return '';

  if (text.includes(',')) {
    return text.replace(/\./g, '').replace(',', '.');
  }

  return text;
};

export const parseCurrencyValue = (value) => {
  const normalized = normalizeCurrencyValue(value);
  const parsed = parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};
